import UrcenieGestoraPage from './UrcenieGestoraPage';

export default UrcenieGestoraPage;
